import classNames from './MoveStudentsPopup.module.scss';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import { StudentReportItem } from '@/school-management/types/response';
import {
  MoveClassDestination,
  BulkOperationResponseData,
  BulkOperationState,
} from '@/school-management/types/services/bulk';
import Button from '@/components/school-management/Button/Button';
import Download from './Download';
import AppIcon from '@/components/school-management/AppIcon/AppIcon';

interface FailureProps {
  students: StudentReportItem[];
  classDestination: MoveClassDestination;
  moveSource: 'ChooseDestination' | 'DifferentGradeAll' | 'DifferentGradeSame';
  bulkOperation?: BulkOperationResponseData;
  onClose: () => void;
  onTryAgain: () => void;
}

const Failure = ({
  students,
  classDestination,
  moveSource,
  bulkOperation,
  onClose,
  onTryAgain,
}: FailureProps) => {
  const { t } = useAdminTranslation();

  return (
    <>
      <button
        className={classNames.closeBtn}
        onClick={onClose}
        aria-label={t('common.cancel') || 'Close'}
      >
        <AppIcon icon='close' size={20} />
      </button>
      <AppIcon size={80} icon='error' className={classNames.icon} />
      <div>
        <div className={classNames.title} style={{ fontSize: '26px' }}>
          {t('bulkActions.common.failureTitle')}
        </div>
        <div className={classNames.description}>{t('bulkActions.common.failureDescription')}</div>
      </div>
      <Download
        students={students}
        classDestination={classDestination}
        moveSource={moveSource}
        bulkOperation={bulkOperation}
        bulkOperationState={BulkOperationState.Failed}
      />
      <div className={classNames.footer} style={{ width: '433px', flexDirection: 'column' }}>
        <Button className={classNames.button} onClick={onTryAgain}>
          {t('common.tryAgain')}
        </Button>
        <Button className={classNames.textButton} onClick={onClose}>
          {t('common.cancel')}
        </Button>
      </div>
    </>
  );
};

export default Failure;
